import React, { useState } from "react";
import BottomAppBar from "../components/BottomBar";
import Navigation from "../components/Navigation";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Loader from "../components/loaders/Loader";
const OpenImage = ({ Link }) => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  function hideLoading() {
    setIsLoading(false);
  }

  return (
    <>
      <Navigation title={t("PRIVACY_POLICY")} appBarColor="orange" />

      <div className="white-card  ">
        <div className="bg-black h-full  flex items-center">
          {isLoading && <Loader />}

          <img src={state?.ImageLink} alt="Foster" onLoad={()=>hideLoading()} />
        </div>
      </div>

      <BottomAppBar />
    </>
  );
};

export default OpenImage;
